import { render, staticRenderFns } from "./DrTaskAssignment.vue?vue&type=template&id=05dab28c&"
import script from "./DrTaskAssignment.vue?vue&type=script&lang=js&"
export * from "./DrTaskAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports